module.exports = __webpack_public_path__ + "img/peseta-sign.d3abe69f.svg";